export const CUSTOM_COLORS = {
    blueGrey: '#607d8b',
    blue: '#0b5394',
    orange: '#ff9800',
    deepPurple: '#673ab7',
    green: '#82c14f',
    darkBlueGray: '#3d4955'
};
